/* eslint-disable no-console */
import { createStore, applyMiddleware, compose } from 'redux';
import rootReducer from '../reducers/rootReducer';
import reduxImmutableStateInvariant from 'redux-immutable-state-invariant';
import thunk from 'redux-thunk';
import {CurrentUser} from "../services/CurrentUser";
import {HttpService} from "../services/api/HttpService";

export default function configureStore(initialState) {

    const tokenRefreshMiddleware = () => {
        return next => async action => {

            const tokenExpiration = CurrentUser.accessTokenExpirationDate;
            const currentTime = new Date().toISOString();

            const tokenIsExpired = (tokenExpiration === undefined || currentTime > tokenExpiration);

            if (tokenIsExpired  && !!CurrentUser.refreshToken) {
                HttpService.create().tryRefreshToken()
                    .catch(err => {
                        console.debug("Failure trying to refresh token in middleware.");
                        console.debug(err);
                    });
            }

            return next(action);
        };
    };

    const middleware = [thunk, tokenRefreshMiddleware];

    if (process.env.NODE_ENV !== 'production') {
        middleware.push(reduxImmutableStateInvariant());
    }

    let composedMiddleware;
    if (window.__REDUX_DEVTOOLS_EXTENSION__) {
        composedMiddleware = compose(
            applyMiddleware(...middleware),
            window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
        );
    } else {
        composedMiddleware = applyMiddleware(...middleware);
    }

    return createStore(
        rootReducer,
        initialState,
        composedMiddleware
    );
}
